import { render, staticRenderFns } from "./wangEnduitcopy.vue?vue&type=template&id=4a983902&lang=html&"
import script from "./wangEnduitcopy.vue?vue&type=script&lang=js&"
export * from "./wangEnduitcopy.vue?vue&type=script&lang=js&"
import style0 from "./wangEnduitcopy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports